import React from 'react'
import { Grid, PageHeader, PageSection } from '@superhi/design'

import LibraryGuideCard from '../../components/LibraryGuideCard'
import Page from '../../components/Page'
import { PageConfig } from '../../routing/types'

import { Props } from './data'
import ROUTE from './route'

const GRID_1_CELL_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 4,
}

const Guides: PageConfig<Props> = ({ guides = [] }) => (
  <Page
    title="Guides"
    description="Free to download, our beginner's guides give you expert advice on design, code and project management, with more to follow."
  >
    <PageHeader
      title="Guides"
      subtitle="Free to download, our beginner's guides give you expert advice on design, code and project management, with more to follow."
      backgroundVersion="YELLOW_02"
      compact
    />

    <PageSection>
      <Grid>
        {guides.map((guide, i) => (
          <Grid.Cell key={guide.slug} span={GRID_1_CELL_SPAN_1}>
            <LibraryGuideCard {...guide} imageLazy={i > 2} />
          </Grid.Cell>
        ))}
      </Grid>
    </PageSection>
  </Page>
)

Guides.route = ROUTE

export { getStaticProps } from './data'
export default Guides
